import React, { FunctionComponent, useState } from "react";

import cls from 'classnames';

import styles from './certificates.module.scss';

import starIcon from '../../../assets/infographic/star.png';
import { useSelector } from "react-redux";
import { getCognitoUserData } from "../../../features/auth/authSlice";
import { selectUser } from "../../../features/users/usersSlice";
import { selectUserRanking } from "../../../features/students/rankingSlice";
import { getTranslations } from "../../../features/translations/translationsUtils";
import { useDeviceSize } from "../../utils/useDeviceSize";
import { SIZES } from "../../common/screen";
import { CertificatesModal } from "./CertificatesModal";

export const Certificates: FunctionComponent<{
  userId?: string
}> = ({ userId }) => {
  const size = useDeviceSize();
  const cognitoUserData = useSelector(getCognitoUserData);
  const cognitoUsername = cognitoUserData
    ? cognitoUserData["cognito:username"]
    : null;
  const userFromStore = useSelector(selectUser(cognitoUsername));
  const userRanking = useSelector(selectUserRanking(userId ?? userFromStore?.username));
  const [opened, setOpened] = useState(false);

  return <>
    <div className={
      cls(styles.container, {
        [styles.mobile]: size === SIZES.PHONE,
      })}>
      <div className={styles.firstColumn}>
        <div className={styles.icon}><img alt="Points" src={starIcon} /></div>
        <div className={styles.content}>
          <div className={styles.points}>{userRanking.certificates?.count ?? 0}</div>
          <div className={cls(styles.description, {
            [styles.mobile]: size === SIZES.PHONE,
          })}>{getTranslations('STUDENT_PROFILE_OBTAINED_CERTIFICATES')}</div>
        </div>
      </div>
      <div className={styles.secondColumn}>
        <div className={styles.viewCertificates} onClick={() => {
          setOpened(true);
        }}>{getTranslations('STUDENT_PROFILE_VIEW_CERTIFICATES')}</div>

      </div>
    </div>
    <CertificatesModal userId={userId} opened={opened} close={() => setOpened(false) } />
  </>;
};